import { folderSchemas } from "@redotech/redo-model/views/folders";
import { viewWithIdSchemas } from "@redotech/redo-model/views/views";
import * as z from "zod";
import { null as zNull } from "zod";

export const saveReplenishmentRequestViewsAndFolders = {
  name: "saveReplenishmentRequestViewsAndFolders" as const,
  input: z.object({
    folders: z.array(folderSchemas["replenishment-requests"]),
    views: z.array(viewWithIdSchemas["replenishment-requests"]),
  }),
  output: zNull(),
};
